export enum AvailableReactivationStatuses {
  Terminated = 'Terminated',
  TerminationInProgress = 'Termination_in_progress',
}

export const REACTIVATION_STEPS = [
  {
    title: 'Review employer and plan settings',
    description: 'All previously used settings have been saved. Verify these settings and add any additional plans being offered.'
  },
  {
    title: 'Load updated census of all employees',
    description: 'Employment statuses may have been updated during the termination process and will not be automatically reverted.'
  },
  {
    title: 'Load enrollment',
    description: 'Previous enrollment will not be automatically reactivated even if the plan was reactivated. Employees must be re-enrolled into each account.'
  },
  {
    title: 'Add or reactivate admin contacts',
    description: 'Previous admin access was removed at the time of termination.'
  },
  {
    title: 'Review payroll calendars',
    description: 'If your plans support scheduled contributions, review any supported payroll calendars.'
  }
];
